<template>
  <div>
    <div class="mt-4">
      <div class="row">
        <div class="col-lg-4">

        </div>
        <div class="col-lg-4 text-center">
          <h3><i @click="removeYear()" class="mr-50 fas fa-arrow-circle-left"></i> {{ year }} <i @click="addYear()"
                                                                                                 class="ml-50 fas fa-arrow-circle-right"></i>
          </h3>
        </div>
        <div class="col-lg-4">

        </div>
      </div>
      <hr>
    </div>
    <div class="mt-4">
      <div class="row">
        <div class="col-md-12">
          <div class="tablemobilewrapper">
            <table class="documentTable">
              <tr class="tableHeaderDocument">
                <th>Nome</th>
                <th>Mese</th>
                <th>Tipo</th>
                <th></th>
              </tr>
              <div class="mt-3" v-if="!documents.data.length > 0">
                Nessun documento disponibile
              </div>
              <tr v-for="document in documents.data" class="tableBookingRow">
                <td>{{ document.name }}</td>
                <td>{{ document.month | filterMonth }}</td>
                <td>{{ document.attachment_type }}</td>
                <td><a
                    v-bind:href="'/owner/attachment/'+ document.id" target="_blank"><i class="fas fa-file-pdf"></i></a>
                </td>
              </tr>
            </table>
          </div>
          <pagination class="mt-3" :data="documents" @pagination-change-page="getDocumentsYear"></pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  components: {},
  name: "HouseDocument",
  props: ['houseId'],
  data: function () {
    return {
      year: new Date().getFullYear(),
      documents: {},
    }
  },
  methods: {
    addYear() {
      this.year = this.year + 1;
      this.getDocumentsYear()

    },
    removeYear() {
      this.year = this.year - 1;
      this.getDocumentsYear()
    },
    getDocumentsYear(page = 1) {
      axios.get('/api/get-attachments-house-altro/' + this.houseId + '/' + this.year + '?page=' + page)
          .then(response => {
                this.documents = response.data.body.attachments;
              }
          )
    },
  },
  mounted() {
    this.getDocumentsYear();
  },
  filters: {
    filterMonth: function (value) {
      if (value == 1) {
        return '1 - Gennaio'
      }
      if (value == 2) {
        return '2 - Febbraio'
      }
      if (value == 3) {
        return '3 - Marzo'
      }
      if (value == 4) {
        return '4 - Aprile'
      }
      if (value == 5) {
        return '5 - Maggio'
      }
      if (value == 6) {
        return '6 - Giugno'
      }
      if (value == 7) {
        return '7 - Luglio'
      }
      if (value == 8) {
        return '8 - Agosto'
      }
      if (value == 9) {
        return '9 - Settembre'
      }
      if (value == 10) {
        return '10 - Ottobre'
      }
      if (value == 11) {
        return '11 - Novembre'
      }
      if (value == 12) {
        return '12 - Dicembre'
      }
      return '';
    }
  }
}
</script>

<style scoped>
.pdf {
  max-width: 20px !important;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  text-align: left;
  padding: 8px;
}

.tableHeaderDocument {
  background: #29235C !important;
  color: #fff !important;
  font-size: 18px !important;
}

.tableHeaderDocument th {
  text-align: center !important;
}

.tableBookingRow {
  border: 2px solid #29235C !important;
  font-weight: 800;
}
.tableBookingRow:hover {
  background: #f8f9fa !important;
  color: #E94E1B !important;
}

.tableBookingRow td{
  text-align: center !important;
}

.tableBookingRow td {

}

.tableHeaderDocument h3 {
  font-size: 18px !important;

}

.titleH2 {
  font-size: 1.75em !important;
  margin: 0 !important;
  margin-bottom: 31px !important;
}

li a {
  font-weight: 700;
  color: #E94E1B !important;

}

h2 {
  color: #E94E1B !important;
}

.attachmentBox {
  text-align: center !important;
}

.attachmentBox img {
  max-width: 55px !important;
}

.attachmentBox h5 {
  font-size: 18px !important;
  font-weight: 700 !important;
  color: #29235C !important;
}

i, h3 {
  color: #29235C !important;
}

i:hover {
  cursor: pointer;
  color: #E94E1B !important;
}

.mr-50 {
  margin-right: 50px !important;
}

.ml-50 {
  margin-left: 50px !important;
}

.noDocuments {
  font-weight: 100 !important;
  font-size: 14px !important;
}

.col-md-4 {
  margin-bottom: 25px !important;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  text-align: left;
  padding: 8px;
}


.tableHeaderBooking th {
  text-align: center;
  background: #29235C !important;
  border: unset;
  color: #fff !important;
}

.documentTable a {
  font-weight: 700;
  color: #E94E1B !important;
}
</style>
